import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRoute = ({ children, roles }) => {

    const userRole = localStorage.getItem('role');

    if (!userRole || !roles.includes(userRole)) {
        return <Navigate to="/login" replace />;
    } else {
        return children ? children : <Outlet />;
    }
};